module.exports = __webpack_public_path__ + "static/media/urdu-box.f399dd99.png";